var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "244px",
    height: "233px",
    viewBox: "0 0 244 233",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_files1_9ool") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 346,
    y: 206,
    width: 748,
    height: 612,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-0.8%",
    width: "101.9%",
    height: "102.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0009871%",
    y1: "100%",
    x2: "50.0009871%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.1,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.05,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100.011179%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.1,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.05,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9990129%",
    y1: "100%",
    x2: "49.9990129%",
    y2: "0%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9938748%",
    y1: "100%",
    x2: "49.9938748%",
    y2: "0%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.1,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.05,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "consent",
    transform: "translate(-593.000000, -292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "undraw_files1_9ool",
    transform: "translate(593.000000, 292.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    points: "152 233 0 233 0 57.3429849 22.9661014 32 152 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFAFA",
    points: "150 228 3 228 3 58.4612604 25.2087843 34 150 34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 16,
    y: 55,
    width: 72,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 18,
    y: 88,
    width: 52,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6C63FF",
    x: 17,
    y: 137,
    width: 118,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 108,
    y: 55,
    width: 27,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 108,
    y: 74,
    width: 27,
    height: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "27 34 27 61 3 61 3 58.6395752 24.6976231 34"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EEEEEE",
    points: "2 58 24 34 24 58"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    points: "198 216 46 216 46 40.3403753 68.9661014 15 198 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFAFA",
    points: "196 211 49 211 49 41.4612604 71.2087843 17 196 17"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 64,
    y: 38,
    width: 72,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 64,
    y: 71,
    width: 52,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6C63FF",
    x: 64,
    y: 120,
    width: 118,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 154,
    y: 38,
    width: 27,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 154,
    y: 57,
    width: 27,
    height: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    points: "74 17 74 44 50 44 50 41.6395752 71.6976231 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EEEEEE",
    points: "50 41 72 17 72 41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-6)",
    points: "244 201 92 201 92 25.3429849 114.9631 0 244 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "242 196 95 196 95 26.4582638 117.211786 2 242 2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 109,
    y: 23,
    width: 72,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 109,
    y: 56,
    width: 52,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6C63FF",
    x: 109,
    y: 106,
    width: 118,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 200,
    y: 23,
    width: 27,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 200,
    y: 42,
    width: 27,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 200,
    y: 61,
    width: 27,
    height: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-7)",
    points: "119 2 119 29 95 29 95 26.6365567 116.697905 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EEEEEE",
    points: "95 27 117 3 117 27"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDocuments);
export default __webpack_public_path__ + "static/media/illustration_documents.4272d8481d71c914679b7cb92057ed8d.svg";
export { ForwardRef as ReactComponent };